<div
  class="list-wrapper pb-2 scrollable"
  [id]="parentElementId"
  (scroll)="onScroll($event)"
  [style]="{ 'max-height': containerHeight }"
>
  @if (isWorkflow) { @switch (appBuilderState) { @case ('loading') {
  <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  } @case ('noRecords') {
  <ng-container *ngTemplateOutlet="noRecordsTemplate"></ng-container>
  } @case ('default') {
  <ng-container *ngTemplateOutlet="productsListTemplate"></ng-container>
  } } } @else { @if (isApiInProgress && !productsList?.length) {
  <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  } @else if (!productsList?.length) {
  <ng-container *ngTemplateOutlet="noRecordsTemplate"></ng-container>
  } @else {
  <ng-container *ngTemplateOutlet="productsListTemplate"></ng-container>
  } }
</div>

<ng-template #loadingTemplate>
  <div class="row mx-0">
    <div class="col-12">
      <div class="col-12" [innerHTML]="renderFetchingTemplate() | safeHtml"></div>
    </div>
  </div>
</ng-template>

<ng-template #noRecordsTemplate>
  <div class="row mx-0">
    <div class="col-12" [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
  </div>
</ng-template>

<ng-template #productsListTemplate>
  @for (product of productsList; track product.productCode) {
  <finxone-web-frontend-list-item
    [textContentStyle]="textContentStyle"
    [customHandlebarModel]="productHandleBarModel(product, $index)"
    [content]="content"
    (itemClicked)="onProductClick(product)"
    [customClass]="
      getItemCustomClasses() + (this.selectedProductCode === product.productCode ? ' selected-item' : '')
    "
  ></finxone-web-frontend-list-item>
  }
</ng-template>
